export default {
  inbound: "Inbound",
  outbound: "Outbound",
  storage: "Storage",
  internal: "Internal Work Orders",

  // Billing type display names
  "Not Applicable": "Not Applicable",
  "Flat Rate/As Quoted (Internal Work Orders)": "Flat Rate/As Quoted",
  "Time and Materials (Blended Rate)": "Time and Materials (Blended Rate)",
  "Time and Materials (Itemized Rates)": "Time and Materials (Itemized Rates)",

  hundredweight_rate: "Hundredweight Rate",
  open_inspect_rate_per_cwt: "Open & Inspect (Per CWT)",
  open_inspect_per_cwt: "Open & Inspect (Per CWT)",
  normal_pallet: "Standard Pallet",
  normal_pallet_rate: "Standard Pallet Rate",
  oversized_pallet: "Oversized Pallet",
  oversized_pallet_rate: "Oversized Pallet Rate",
  double_oversized_pallet: "Double Oversized Pallet",
  double_oversized_pallet_rate: "Double Oversized Pallet Rate",
  minimum_charge: "Minimum Charge",
  minimum_charge_rate: "Minimum Charge",
  transaction_processing_rate: "Handling Charge (Per Transaction)",
  transaction_rush_rate: "Hotshot Fee",
  standard_unit_rate: "Standard Unit Rate",
  per_item_rate: "Per Unit/Item Rate",
  square_foot_item_dimensions_rate: "Square Foot by Item Dimensions Rate",
  square_foot_location_dimensions_rate: "Square Foot by Location Dimensions Rate",
  cubic_foot_item_dimensions_rate: "Cubic Foot by Item Dimensions Rate",
  cubic_foot_location_dimensions_rate: "Cubic Foot by Location Dimensions Rate",
  flat_rate: "Flat Rate",
  time_and_materials_rate: "Time and Materials (Blended Rate)",
  installer_rates: "Installer Rates",
  warehouse_labor_rates: "Warehouse Labor Rates",
  fork_lift_rates: "Forklift Rates",
  per_vault_rate: "Per Vault Rate",
  per_vault: "Vault Used",
  per_rack_location_rate: "Per Rack Location Rate",
  per_oversized_rack_location_rate: "Per Oversized Rack Location Rate",
  per_floor_location_rate: "Per Floor Location Rate",
  per_trailer_rate: "Per Trailer Rate",

  oi_cartons: "O&I Carton",
  cartons_1_5: "1.5cu Carton",
  cartons_3_0: "3.0cu Carton",
  cartons_4_5: "4.5cu Carton",
  cartons_6_0: "6.0cu Carton",
  moving_tote: "Moving Tote/Crate",

  bubble_wrap: "Bubble Wrap",
  anti_static_bubble_wrap: "Bubble Wrap (Anti-Static)",
  shrink_wrap: "Shrink Wrap",
  anti_static_shrink_wrap: "Shrink Wrap (Anti-Static)",
  packing_tape: "Packing Tape (per roll)",
  corner_board: "Corner Board (72\" strip)",
  steel_strapping: "Steel Strapping (per pallet)",
  straping_protector: "Strapping Protector (per pallet)",

  pads: "Pad (Moving Blanket)",
  paper_pads: "Paper Pad",
  c_bin: "C-Bin",
  dolly: "4-Wheel Dolly",

  wms_manager: "WMS Manager",
  straight_truck: "Straight Truck",
  driver: "Straight Truck Driver",
};
